import React, { useState, useEffect, useRef } from "react";
import moment from 'moment';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { SearchLayouts, SearchOverlays } from 'data/search';
import Paginator from 'components/Paginator';
import SVG from 'components/base/SVG';
import Image from 'components/base/Image';
import DEFAULT_IMAGE_URL from 'assets/favicon.png';
import Table from 'components/base/Table';
import Button from 'components/base/Button';
import Checkbox from 'components/base/Checkbox';
import { MinMaxInput } from 'components/base/Input';
import { SearchFields, SearchNames, SearchTables, PicViewFields, SearchTypes, SearchDataType, SearchFullTable, SearchLiensTable, SearchTypeCustom, SearchTypeDefault } from 'data/search';
import formatDate from 'utils/date/formatDate';
import formatDateYearMonth from 'utils/date/formatDate';
import numberFormat from 'utils/number/format';
import numberToPrice from 'utils/currency/numberToPrice';
import stopPropagation from 'utils/DOM/propagation';
import BedIcon from '../../../assets/images/Bed.svg';
import Bath from '../../../assets/images/Bath.svg';
import LotSize from '../../../assets/images/LotSize.svg';
import SqFt from '../../../assets/images/SqFt.svg';
import Home from '../../../assets/images/home-white.svg';
import Bookmark from '../../../assets/images/SaveIcon-NotSaved.svg';
import Bookmarkwhite from '../../../assets/images/bookmark_white.svg';
import Gallery from '../../../assets/images/gallery.svg';
import GalleryWhite from '../../../assets/images/gallery-white.svg';

import Auction from "../../../assets/images/auction.svg";
import OnMarket from "../../../assets/images/mls.svg";
import PreForeclosures from "../../../assets/images/pre-foreclosures.svg";
import BankOwned from "../../../assets/images/bank-owned.svg";
import CashBuyers from "../../../assets/images/cash-buyer.svg";
import Liens from "../../../assets/images/liens.svg";
import Vacant from "../../../assets/images/vacant.svg";
import HighEquity from "../../../assets/images/high-equity.svg";

import Bankruptcy from "../../../assets/images/bankruptcy.svg";
import Divorce from "../../../assets/images/divorce.svg";
import FailedListings from "../../../assets/images/failedListings.svg";
import Flippers from "../../../assets/images/flippers.svg";
import FreeClear from "../../../assets/images/free-and-clear.svg";
import PreProbate from "../../../assets/images/pre-probate.svg";
import SeniorOwners from "../../../assets/images/senior-owners.svg";
import TaxDelinquency from "../../../assets/images/tax-delinquency.svg";
import TiredLandlords from "../../../assets/images/tired-landlords.svg";
import UpsideLand from "../../../assets/images/upside-down.svg";
import VacantLand from "../../../assets/images/SearchVacantIcon.svg";
import ZombieProperties from "../../../assets/images/zombie-properties.svg";

import NoimageSearchCard from "../../../assets/images/nophoto-searchtile.jpg";
import css from './style.scss';
import ColumnsRenderers from '../Columns';
import { isNDAState } from '../../../utils/ndaStates';

//PropertyTypeIconsResidentialIcon
import ResidentialIcon from '../../../assets/images/ResidentialIcon.svg';
import CommercialIcon from '../../../assets/images/CommercialIcon.svg';
import OfficeIcon from '../../../assets/images/OfficeIcon.svg';
import IndustrialIcon from '../../../assets/images/IndustrialIcon.svg';
import AgricultureIcon from '../../../assets/images/AgricultureIcon.svg';
import RecreationalIcon from '../../../assets/images/RecreationalIcon.svg';
import TransportationIcon from '../../../assets/images/TransportationIcon.svg';
import ExemptIcon from '../../../assets/images/ExemptIcon.svg';
import VacantLandIcon from '../../../assets/images/VacantLandIcon.svg';

import { openGallery } from '../../Property/Gallery/GalleryPortalRenderer';
import ImageDefault from '../../../assets/images/Img.svg'
import ImageHover from '../../../assets/images/HoverImg.svg'

import NotSave from '../../../assets/images/SaveIcon-NotSaved.svg'
import SaveIcon from '../../../assets/images/SaveIcon-Saved.svg'
import SaveHoverIcon from '../../../assets/images/SaveIcon-Hover.svg'
import AdditionalLeadListModal from "../../components/RecentListModal/ListModal";
import RecentProperty from "../../components/RecentProperty";
import ListModal from "../../components/RecentListModal/ListModal";
import AssumableMtg from "../../../assets/images/Lead-List-Icons.svg";
import formatPercent from 'utils/percent/formatPercent';

const Characteristics = [
  { field: 'bedrooms', label: 'Bd.', image: <img src={BedIcon} style={{ width: '20px', height: '20px' }} alt="Bed" /> },
  { field: 'bathrooms', label: 'Ba.', image: <img src={Bath} style={{ width: '20px', height: '20px' }} alt="Bed" /> },
  { field: 'squareFeet', label: 'SQFT', formatter: numberFormat, image: <img style={{ width: '20px', height: '20px' }} src={SqFt} alt="SqFt" /> },
  { field: 'lotSquareFeet', label: 'LOT', formatter: numberFormat, image: <img style={{ width: '20px', height: '20px' }} src={LotSize} alt="LotSize" /> },
];

const propertyTypeIcons = {
  M: { src: OnMarket, alt: 'OnMarket', label: 'On Market' }, P: { src: PreForeclosures, alt: 'PreForeclosures', label: 'Pre-Foreclosures' }, A: { src: Auction, alt: 'Auctions', label: 'Auction' },
  F: { src: BankOwned, alt: 'BankOwned', label: 'Bank Owned' }, C: { src: CashBuyers, alt: 'CashBuyers', label: 'Cash Buyers' }, V: { src: Vacant, alt: 'Vacant', label: 'Vacant' },
  L: { src: Liens, alt: 'Liens', label: 'Liens' }, E: { src: HighEquity, alt: 'HighEquity', label: 'High Equity' }, D: { src: Divorce, alt: 'Divorce', label: 'Divorce' },
  B: { src: Bankruptcy, alt: 'Bankruptcy', label: 'Bankruptcy' }, Z: { src: FailedListings, alt: 'FailedListings', label: 'Failed Listings' }, I: { src: Flippers, alt: 'Flippers', label: 'Flippers' },
  R: { src: FreeClear, alt: 'FreeClear', label: 'Free & Clear' }, DEC: { src: PreProbate, alt: 'PreProbate', label: 'Pre-Probate' }, S: { src: SeniorOwners, alt: 'SeniorOwners', label: 'Senior Owners' },
  X: { src: TaxDelinquency, alt: 'TaxDelinquency', label: 'Tax Delinquency' }, T: { src: TiredLandlords, alt: 'TiredLandlords', label: 'Tired Landlords' }, UD: { src: UpsideLand, alt: 'UpsideLand', label: 'Upside Down' },
  VLN: { src: VacantLand, alt: 'VacantLand', label: 'Vacant Land' }, ZOM: { src: ZombieProperties, alt: 'ZombieProperties', label: 'Zombie Properties' }, G: { src: AssumableMtg, alt: 'Assumable Mortgages', label: 'Assumable Mortgages' }
};

const CircularProgress = ({ percentage = 0, size = 28, strokeWidth = 4, color = '#128292', backgroundColor = '#DFE1E4' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - Math.max(0, Math.min(percentage, 100)) / 100 * circumference;

  return (
    <svg width={size} height={size}>
      <circle
        stroke={backgroundColor}
        fill="none"
        strokeWidth={strokeWidth}
        cx={size / 2}
        cy={size / 2}
        r={radius}
      />
      <circle
        stroke={color}
        fill="none"
        strokeWidth={strokeWidth}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text
        x="50%"
        y="50%"
        // dy="1px"
        textAnchor="middle"
        dominantBaseline="middle"
        alignmentBaseline="central"
        fontSize="11"
        fill={color}
        fontWeight="bold"
      >
        {`${Math.max(0, Math.min(percentage, 100))}`}
      </text>
    </svg>
  );
};

// SQFT/LOT
const CharacteristicsRow = ({ characteristicFields, item }) => {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);
  const [tooltipText, setTooltipText] = useState("");

  const handleMouseEnter = () => {
    const container = containerRef.current;
    if (!container) return;

    const isOverflowing = container.scrollWidth > container.clientWidth;

    if (isOverflowing) {
      const containerRect = container.getBoundingClientRect();

      const hiddenItems = itemRefs.current.filter((ref) => {
        if (!ref) return false;
        const rect = ref.getBoundingClientRect();
        return rect.right > containerRect.right || rect.left < containerRect.left;
      });

      const result = hiddenItems
        .map((ref) => ref.dataset.value)
        .filter(Boolean)
        .join(" | ");

      setTooltipText(result);
    } else {
      setTooltipText("");
    }
  };

  return (
    <div className={css.characteristicsRow}>
      <div
        ref={containerRef}
        onMouseEnter={handleMouseEnter}
        title={tooltipText || undefined}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          minWidth: 0,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          minHeight: "24px",
        }}
      >
        {characteristicFields.map((c, index) => {
          const value = (c.formatter || ((v) => v))(item.get(c.field));
          const fullText = `${value} ${c.label || ""}`.trim();

          return (
            <div
              key={c.field}
              ref={(el) => (itemRefs.current[index] = el)}
              data-value={fullText}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexShrink: 0,
              }}
            >
              {/* Optional Icon */}
              {c.image && <span>{c.image}</span>}

              <div style={{ display: "flex", alignItems: "baseline", gap: "3px" }}>
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "14px",
                    color: "#3C4654",
                    lineHeight: "14px",
                    fontFamily: "Inter",
                  }}
                >
                  {value}
                </span>

                {(c.field === "squareFeet" || c.field === "lotSquareFeet") && (
                  <span className={css.feet}>{c.label}</span>
                )}
              </div>

              {index !== characteristicFields.length - 1 && (
                <span
                  style={{
                    width: "1px",
                    height: "20px",
                    backgroundColor: "#DFE1E4",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const BIG_COUNTER = (10 ** 3) - 10;


const btn = { size: Button.size.small, kind: Button.kind.blueGhost };

const Results = ({ onChangePage, onChangeRange, onSelect, onSaveProperty, onSaveList, inputFlag, setInputFlag, history, result, filter, activeContext: ac, onSort, onClick, sort, activeMarker, onRangeFrom, onRangeTo, onReset, onLoadMore, isLoading, lazyDone, scrollToPropertyId, onToggleAction }) => {

  const results = ac.get('displayResults');
  const resultCount = ac.get('resultCount');
  const selectionCount = ac.get('selectionCount');
  const allSelected = ac.get('allSelected');
  const rangeFrom = ac.get('rangeFrom');
  const rangeTo = ac.get('rangeTo');
  const rangeEnabled = ac.get('rangeEnabled');
  const pageIndex = ac.get('pageIndex');
  const pageCount = ac.get('pageCount');
  const [hoveredGalleryId, setHoveredGalleryId] = useState(null);
  const [isActionDropdownOpen, setIsActionDropdownOpen] = useState(false);
  const toggleActionDropdown = () => setIsActionDropdownOpen(prev => !prev);
  const [isPressed, setIsPressed] = useState(false);
  const [hoveredSaveId, setHoveredSaveId] = useState(null);
  const [isClicked, setIsClicked] = useState(false);

  const type = filter.get('type');
  const viewRef = useRef(null);

  const [modalPropertyId, setModalPropertyId] = useState(null);

  useEffect(() => {
    if (scrollToPropertyId && viewRef.current && selectionCount) {
      const container = viewRef.current;
      const target = container.querySelector(`#property-${scrollToPropertyId}`);
      if (target) {
        // Optional: Ensure a smooth scroll without affecting layout
        setTimeout(() => {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        }, 100); // Delay ensures layout is settled
      }
    }
  }, [scrollToPropertyId]);




  const scrollToProperty = (propertyId) => {
    if (!propertyId || !viewRef.current) return;

    setTimeout(() => {
      const propertyElement = viewRef.current.querySelector(`[data-property-id="${propertyId}"]`);

      if (propertyElement) {
        // Calculate scroll position to center the element
        const containerRect = viewRef.current.getBoundingClientRect();
        const elementRect = propertyElement.getBoundingClientRect();
        const scrollTop = viewRef.current.scrollTop;

        const targetScrollTop = scrollTop + elementRect.top - containerRect.top - (containerRect.height / 2) + (elementRect.height / 2);

        // Smooth scroll to the element
        viewRef.current.scrollTo({
          top: Math.max(0, targetScrollTop),
          behavior: 'smooth'
        });

        // Call onScrollComplete if provided
        if (onScrollComplete) {
          setTimeout(() => onScrollComplete(), 1000);
        }
      }
    }, 100);
  };


  useEffect(() => {
    const el = viewRef.current;
    const handleScroll = () => {
      if (!el || typeof onLoadMore !== 'function') return;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 100;
      if (nearBottom) {
        onLoadMore();
      }
    };

    if (el) el.addEventListener('scroll', handleScroll);
    return () => el?.removeEventListener('scroll', handleScroll);
  }, [results, resultCount, onLoadMore]);




  useEffect(() => {
    const handleClickOutside = e => {
      if (!e.target.closest(`.${css.actionWrapper}`)) setIsActionDropdownOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  let columns;
  if (result.get('overlay') === SearchOverlays.Property) columns = SearchTables[type === 'L' ? SearchLiensTable : SearchFullTable];
  else if (result.get('layout') === SearchLayouts.Grid) columns = SearchTables[SearchTypes[type] || SearchTypeCustom] || SearchTables[SearchTypeDefault];
  const [recentPulseIds, setRecentPulseIds] = useState(() => new Set());
  const [showAddressTooltip, setShowAddressTooltip] = useState(false);
  const handleMouseEnterAddress = e =>
    setShowAddressTooltip(e.target.offsetWidth < e.target.scrollWidth);

  const showTooltipIfEllipsis = (e) => {

    const span = e.currentTarget;
    const box = span.closest(`.${css.bookmark}`);

    if (box && box.offsetWidth < span.scrollWidth) {
      span.title = span.dataset.full;
    } else {
      span.removeAttribute('title');
    }
  };

  const handleGalleryClick = (id) => {
    openGallery({ id: id });
  };

  const cancelClick = () => {
    onChangeRange({ name: 'rangeEnabled', value: false })
    onChangeRange({ name: 'rangeFrom', value: '' });
    onChangeRange({ name: 'rangeTo', value: '' });
    setInputFlag(false)
    onReset()
    onSelect('all', false);
  }

  const getSavedKey = (item) => item.get('id');

  const [savedLocalIds, setSavedLocalIds] = useState(() => new Set());

  const isItemSaved = (item) =>
    savedLocalIds.has(getSavedKey(item)) ||
    Boolean(item.get('savedPropertyId') || item.get('saved'));

  const handleSaveClick = (e, item) => {
    e.stopPropagation();
    const idKey = getSavedKey(item);

    if (typeof onSaveProperty === 'function') {
      onSaveProperty(idKey, item);

      setSavedLocalIds(prev => {
        const s = new Set(prev);
        s.add(idKey);
        return s;
      });

      // Force-show RecentProperty briefly after save
      setRecentPulseIds(prev => {
        const s = new Set(prev);
        s.add(idKey);
        return s;
      });
      setTimeout(() => {
        setRecentPulseIds(prev => {
          const s = new Set(prev);
          s.delete(idKey);
          return s;
        });
      }, 2000); // show for 2 seconds (tweak as needed)

      setHoveredSaveId(null);
    }
  };

  const getIcon = (item) => {
    const hovering = hoveredSaveId === item.get('id');
    return isItemSaved(item) ? SaveIcon : (hovering ? SaveHoverIcon : NotSave);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hoveredClassTagId, setHoveredClassTagId] = useState(null);
  const [modalPropertyIndex, setModalPropertyIndex] = useState(null);
  const handleAdditionalClick = (item, index, e) => {
    // e.stopPropagation();
    setIsModalOpen(true);
    setModalPropertyId(item.get('id'));
    setModalPropertyIndex(index);
  };

  return (
    <div className={css.wrapper}>
      <div className={css.resultsHeader}>

        {/* {!resultCount ? null : ( */}
        <div className={css.content}>
          <div className={css.left} >
            <div className={css.checkboxWrapper}>
              <label className={css.checkboxContainer}>
                <input
                  type="checkbox"
                  ref={(el) => {
                    if (el) el.indeterminate = selectionCount > 0 && !allSelected;
                  }}
                  checked={allSelected}
                  onChange={(e) => {
                    if (selectionCount > 0 && !allSelected) {
                      onSelect('all', false);
                    } else {
                      onSelect('all', e.target.checked);
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  disabled={!resultCount}
                  style={
                    !resultCount
                      ? {
                        border: '1px solid #DFE1E4',
                        background: '#FFF',
                        borderColor: '#DFE1E4',
                        pointerEvents: 'none',
                        cursor: 'not-allowed',
                      }
                      : {}
                  }
                />
                <span className={css.checkmark} style={
                  !resultCount
                    ? {
                      borderColor: '#DFE1E4',
                      pointerEvents: 'none',
                      cursor: 'not-allowed',
                    }
                    : {}
                }>
                  {selectionCount > 0 && !allSelected ? (
                    // Indeterminate icon (horizontal bar)
                    <svg className={css.rectangle}>
                      {/* <rect x="6" y="11" width="14" height="2.5" rx="1" fill="#fff" /> */}
                    </svg>
                  ) : allSelected ? (
                    // Checkmark
                    <svg viewBox="0 0 24 24" className={css.svgIcon}>
                      <path
                        d="M5 13L9.5 17.5L19 7"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : null}
                </span>
              </label>
            </div>

            <>
              {selectionCount ? (
                <>
                  <div className={css.mulcaption}>
                    <span className={css.mulcaptionVal}>{selectionCount.toLocaleString()} <span className={css.mulcaptiontxt}> SELECTED </span></span>

                    <div className={css.mulselected}>
                      <span className={css.mulselectedVal}>{resultCount.toLocaleString()}</span><span className={css.mulcaptionprtxt}>PROPERTIES</span>
                    </div>
                  </div>

                </>
              ) : (
                <div className={css.caption}>
                  <span className={css.captionVal}>{resultCount.toLocaleString()}</span><span className={css.captiontxt}>PROPERTIES</span>
                </div>
              )}
            </>
          </div>
          <div className={css.right}>
            <div className={css.actionWrapper}>
              <div
                className={classNames(css.dropdownToggleBtn, { [css.disabled]: !resultCount })}
                onClick={(e) => {
                  if (!resultCount) return;
                  toggleActionDropdown(e);
                  if (onToggleAction) onToggleAction();
                }}
                aria-disabled={!resultCount}
              >
                Actions
                <SVG icon={isActionDropdownOpen ? "iconCaretUp" : "iconCaretDown"} className={css.dropdownCaretIcon} />
              </div>

              {isActionDropdownOpen && (
                <div className={css.dropdownCard}>
                  <div
                    className={css.dropdownItem}
                    onClick={() => {
                      setInputFlag(true);
                      onChangeRange({ name: 'rangeEnabled', value: true });
                      setIsActionDropdownOpen(false)
                    }}
                  >
                    Input Range
                  </div>

                  <div className={classNames(css.dropdownItem, { [css.dropdownItemHighlight]: selectionCount > 0, [css.dropdownItemDisabled]: selectionCount === 0 })}
                    onClick={() => {
                      if (selectionCount > 0) {
                        onSaveList();
                        setIsActionDropdownOpen(false)
                      }
                    }}
                  >
                    Save
                  </div>

                </div>
              )}
            </div>
          </div>
        </div>
        {/* )} */}
        {rangeEnabled &&
          <div className={css.verticalDivider}></div>
        }
        {rangeEnabled && (
          <div className={css.rangeSection}>
            <div className={css.rangeInputsRow}>
              <div className={css.dualInputs}>
                <MinMaxInput
                  name="rangeFrom"
                  value={onRangeFrom}
                  placeholder="1"
                  min={1} max={rangeTo || resultCount}
                  onChange={onChangeRange}
                  className={css.inputBoxLeft}
                />
                <MinMaxInput
                  name="rangeTo"
                  value={onRangeTo}
                  placeholder={resultCount}
                  onChange={onChangeRange}
                  min={rangeFrom || 1} max={resultCount}
                  className={css.inputBoxRight}
                />
              </div>

              <span className={css.ofText}>
                OF <span className={css.totalCount}>{resultCount.toLocaleString()}</span>
              </span>
            </div>

            <div className={css.rangeActionsRow}>

              <button className={css.rangeCancelBtn} onClick={() => cancelClick()}>Cancel</button>
              <button className={css.confirmBtn} onClick={() => {
                onChangeRange({ name: 'filterEnable', value: true })
                // onSelect('all', true);
              }}>
                Show Property Range
              </button>
            </div>
          </div>
        )}
      </div>
      <div ref={viewRef} className={css.view}>
        {resultCount ? null : (
          <div className={css.container}>
            <h3>No Matching Results.</h3>
            <h5>Please try changing or expanding your search criteria.</h5>
          </div>
        )}

        {!resultCount ? null : (
          <div className={css.content}>
            {!columns ? null : (
              <Table data={results} onRowClick={onClick} onColumnSort={onSort} sortFields={sort} keyField="id" className="type_11" isSortable isHoverable>
                {ColumnsRenderers.CHECKBOX({ onSelect })}
                {columns.map(
                  column => ColumnsRenderers[column]({ activeMarker },
                    <SVG icon={ac.get('sortAscending') ? 'iconCaretUp' : 'iconCaretDown'} />),
                )}
              </Table>
            )}
            {columns ? null : (results.map((item) => {
              const id = item.get('id');
              const link = `/search/${item.get('propertyId')}`;
              const index = item.get('resultIndex');
              const code = item.get('propertyClassCode')
              const types = item.get('propertyType')
              const landUse = item.get('landUse');
              const saved = !!item.get('savedPropertyId');
              const savedPropertyCount = item.get('savedPropertyCount');
              const groupName = item.getIn(['group', 'name']) || '';
              const groupId = item.getIn(['group', 'id']);
              const isSaved = isItemSaved(item);

              const street = item.getIn(['address', 'streetAddress']) || '';
              const city = item.getIn(['address', 'cityName']) || '';
              const state = item.getIn(['address', 'stateCode']) || '';
              const zip = item.getIn(['address', 'zip']) || '';
              const isValid = (val) =>
                typeof val === 'string' &&
                val.trim() !== '' &&
                !val.includes('0000') &&
                !val.includes('00000') &&
                !val.includes('<No Street Address>') &&
                val.toLowerCase() !== 'undefined';

              let address = '';
              const savedNow = isItemSaved(item);

              if (isValid(street)) address += street;

              if (isValid(city)) {
                if (address) address += ' ';
                address += city;
              }

              const stateZip = [state, zip].filter(isValid).join(' ');
              if (stateZip) {
                if (address) address += ', ';
                address += stateZip;
              }

              const fullAddress = isValid(state) && address.trim() == state ? 'Address Unavailable' : address || 'Address Unavailable';

              let type = item.get('type');

              if (type === 'P' && item.get('auctionDate')) type = 'A';
              else if (type === 'I') type = 'M';
              const quickInfoFields = (PicViewFields[type] || PicViewFields[SearchTypeCustom]).filter(({ value }) => {
                if (value !== 'MORTGAGE1_INTEREST_RATE') return true;

                const val = item.get(SearchFields[value]);
                return val !== 'N/A' && val !== '' && val != null && Number(val) !== 0;
              });
              const imageUrl = item.get('imageUrl');

              const isFallbackImage =
                imageUrl === '' ||
                imageUrl.includes('coming_soon') ||
                imageUrl.includes('photo_coming_soon') ||
                imageUrl.includes('house-img-not-available') ||
                imageUrl.includes("placeholder")

              const updatedImageUrl = (() => {
                if (!imageUrl) return imageUrl;
                try {
                  const url = new URL(imageUrl);
                  const hostParts = url.hostname.split('.');

                  if (
                    hostParts.length === 4 &&
                    hostParts[0] === 'images' &&
                    hostParts[2] === 'propstream' &&
                    hostParts[3] === 'com'
                  ) {
                    hostParts.splice(1, 1);
                    url.hostname = hostParts.join('.');
                  }

                  return url.toString();
                } catch {
                  return imageUrl;
                }
              })();

              const imageUrls = isFallbackImage
                ? '../../../assets/images/nophoto-searchtile.jpg'
                : updatedImageUrl;

              const iconMap = {
                R: ResidentialIcon,
                C: CommercialIcon,
                O: OfficeIcon,
                I: IndustrialIcon,
                A: AgricultureIcon,
                F: RecreationalIcon,
                T: TransportationIcon,
                E: ExemptIcon,
                V: VacantLandIcon,
              };

              const propertyClassLabel = {
                R: 'Residential',
                C: 'Commercial',
                O: 'Office',
                I: 'Industrial',
                A: 'Agriculture',
                F: 'Recreational',
                T: 'Transportation',
                E: 'Exempt',
                V: 'Vacant Land',
              };

              const getLabelFromClassCode = (code) => propertyClassLabel[code];
              const characteristicFields = Characteristics.filter(c =>
                !!item.get(c.field)
              );

              return (
                <div
                  id={`property-${item.get('id')}`}
                  key={`${type}${item}`}
                  className={classNames(css.item, { [css.itemChecked]: item.get('selected'), [css.bigCounter]: index >= BIG_COUNTER })}
                  style={{
                    cursor: (inputFlag || selectionCount > 0 || rangeEnabled) ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    if (inputFlag || selectionCount > 0 || rangeEnabled) onSelect(item.get('id'), !item.get('selected'));
                    onClick(item.get('id'), item);
                  }}
                >
                  <div className={css.imageDiv}>
                    <img className={css.bg} src={imageUrls} alt="" />
                  </div>
                  <div className={css.footerDiv}>
                    <div className={css.headerContent} style={{ zIndex: 1 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", gap: "14px" }}>
                        <div className={css.bodyContent}>

                          <div className={css.topIcons}>
                            {/* <Checkbox onChange={onSelect} changeValue={id} checked={item.get('selected')} /> */}
                            <div className={css.checkboxWrapper}>
                              <label className={css.checkboxContainer}>
                                <input
                                  type="checkbox"
                                  checked={item.get('selected')}
                                  onChange={(e) => onSelect(id, e.target.checked)}
                                  onClick={(e) => e.stopPropagation()}
                                />
                                <span className={css.checkmark}>
                                  <svg viewBox="0 0 24 24" className={css.svgIcon}>
                                    <path
                                      d="M5 13L9.5 17.5L19 7"
                                      fill="none"
                                      stroke="#fff"
                                      strokeWidth="2.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </label>
                            </div>
                            {inputFlag || selectionCount > 0 || rangeEnabled ? (
                              <div className={css.indextag}>
                                <span className={css.indexspan}>{index}</span>
                              </div>
                            ) : (
                              <div className={css.headResult}>
                                <div className={css.tagParent}>
                                  <div
                                    className={`${css.tag} ${css.fadeInOut}`}
                                    onClick={stopPropagation}
                                    onMouseDown={stopPropagation}
                                    onKeyDown={stopPropagation}
                                    role="group"
                                    onMouseEnter={() => setHoveredClassTagId(id)}
                                    onMouseLeave={() => setHoveredClassTagId(null)}
                                  >
                                    <div className={css.tagIconWrapper}>
                                      <img
                                        src={iconMap[code] || ResidentialIcon}
                                        className={css.iconProperties}
                                        alt={item.propertyType || 'Property'}
                                      />
                                    </div>
                                    <span
                                      className={css.res}
                                      style={{ height: '28px', padding: '5px 0' }}
                                    >
                                      {code ? `${getLabelFromClassCode(code)} - ${landUse}` : `${landUse}`}
                                    </span>
                                  </div>
                                </div>

                                <div className={css.fadeChild}>
                                  {!(inputFlag || selectionCount > 0) &&
                                    (isSaved || recentPulseIds.has(id)) && (
                                      <RecentProperty
                                        listName={groupName}
                                        count={savedPropertyCount}
                                        groupId={groupId}
                                        isIconHovered={(hoveredClassTagId === id) || recentPulseIds.has(id)}
                                        onAdditionalClick={(e) => handleAdditionalClick(item, index, e)}
                                        redirectFlag={true}
                                        disabled={true}
                                      />
                                    )}
                                </div>

                              </div>
                            )}
                          </div>
                          {!isFallbackImage && !(inputFlag || selectionCount > 0) && (
                            <button
                              className={`${css.imageIconButton} ${isClicked ? css.clicked : ''}`}
                              onClick={e => { e.stopPropagation(); handleGalleryClick(id); }}
                              onMouseDown={() => setIsClicked(true)}
                              onMouseUp={() => setIsClicked(false)}
                              onMouseLeave={() => setIsClicked(false)}
                            >
                              <img src={ImageDefault} alt="Default" className={`${css.imageIcon} ${css.imgDefaultIcon}`} />
                              <img src={ImageHover} alt="Hover" className={`${css.imageIcon} ${css.imgHoverIcon}`} />
                            </button>
                          )}
                        </div>
                        <div className={css.info} >
                          <div className={css.header}>
                            <div className={css.left} style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                              {item.get('onMarket') === true ? (
                                <div className={css.bookmark}>
                                  <div className={css.value} style={{ display: "flex", alignItems: "baseline" }}>
                                    {typeof item.getIn(['mlsListingAmount']) === 'number' && !isNaN(item.getIn(['mlsListingAmount'])) ? (
                                      <>
                                        <span
                                          className={css.value}
                                          data-full={`${numberToPrice(item.getIn(['mlsListingAmount']))}`}
                                          onMouseEnter={showTooltipIfEllipsis}
                                        >
                                          {numberToPrice(item.getIn(['mlsListingAmount']))}
                                        </span>
                                        <span className={css.estvalue}>LIST PRICE</span>
                                      </>
                                    ) : (
                                      'N/A'
                                    )}
                                  </div>
                                  <div
                                    className={classNames(css.tag, {
                                      [css.hoverable]: !savedNow,
                                      [css.disabled]: (savedNow || rangeEnabled || inputFlag || selectionCount > 0),
                                    })}
                                    aria-disabled={savedNow}
                                    onMouseEnter={!savedNow ? () => setHoveredSaveId(id) : undefined}
                                    onMouseLeave={!savedNow ? () => setHoveredSaveId(null) : undefined}
                                    onClick={!savedNow ? (e) => handleSaveClick(e, item) : undefined}
                                    style={savedNow ? { pointerEvents: 'none' } : undefined}
                                  >
                                    {(!savedNow && hoveredSaveId === id) && <span className={css.res}>Save</span>}
                                    <img
                                      src={getIcon(item)}
                                      className={css.iconProperties}
                                      alt="Save"
                                    />
                                  </div>
                                </div>
                              ) : (
                                !numberToPrice(item.get('estimatedValue', 0)) ? null : (
                                  <div className={css.bookmark}>
                                    <div className={css.value}>
                                      {typeof item.get('estimatedValue') === 'number' && !isNaN(item.get('estimatedValue')) ? (
                                        <>
                                          <span data-full={`${numberToPrice(item.get(['estimatedValue']))}`}
                                            onMouseEnter={showTooltipIfEllipsis}>
                                            {numberToPrice(item.get('estimatedValue'))}
                                          </span>
                                          <span className={css.estvalue}> EST. VALUE </span>
                                        </>
                                      ) : (
                                        'N/A'
                                      )}
                                    </div>
                                    <div
                                      className={classNames(css.tag, {
                                        [css.hoverable]: !savedNow,
                                        [css.disabled]: (savedNow || rangeEnabled || inputFlag || selectionCount > 0),
                                      })}
                                      aria-disabled={savedNow}
                                      onMouseEnter={!savedNow ? () => setHoveredSaveId(id) : undefined}
                                      onMouseLeave={!savedNow ? () => setHoveredSaveId(null) : undefined}
                                      onClick={!savedNow ? (e) => handleSaveClick(e, item) : undefined}
                                      style={savedNow ? { pointerEvents: 'none' } : undefined} // optional hard block
                                    >
                                      {(!savedNow && hoveredSaveId === id) && <span className={css.res}>Save</span>}
                                      <img
                                        src={getIcon(item)}
                                        className={css.iconProperties}
                                        alt="Save"
                                      />
                                    </div>
                                  </div>
                                )
                              )}
                              <div
                                className={classNames(css.name, {
                                  [css.disabled]: (inputFlag || selectionCount > 0 || rangeEnabled)
                                })}
                                title={showAddressTooltip ? fullAddress : ''}
                                onMouseEnter={handleMouseEnterAddress}
                              >
                                {/* {(inputFlag || selectionCount > 0 || rangeEnabled) ? (
                                  <span className={`${css.textOnly} ${css.disabledAddress} ${css.noPointer}`}>
                                    {fullAddress}
                                  </span>
                                ) : ( */}
                                <Link
                                  to={`/search/${item.get('id')}`}
                                  className={css.textOnly}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onClick(item.get('id'), item);
                                  }}
                                >
                                  {fullAddress}
                                </Link>
                                {/* )} */}
                              </div>
                            </div>
                          </div>

                          <CharacteristicsRow characteristicFields={characteristicFields} item={item} />

                        </div>
                      </div>
                      {/* #Slitter */}
                      <div style={{ borderBottom: '1px solid #DFE1E4', margin: '12px 0' }} />
                    </div>

                    <div className={css.footer}>
                      {quickInfoFields.map(({ type, value, label }, index) => {
                        const field = SearchFields[value];
                        let val = item.get(field);

                        if (val || val === 0) {
                          if (type === SearchDataType.DATE) {
                            val = formatDate(val, null, null, item.get(`${field}Format`));
                          } else if (type === SearchDataType.PRICE) {
                            val = numberToPrice(val);
                          } else if (type === 'PERCENT') {
                            val = formatPercent(parseFloat(val) * 100, null, {
                              maximumFractionDigits: 2
                            });
                          }
                        } else if (item.get('type') !== 'O') {
                          val = 0;
                        } else if (item.get('type') === 'O') {
                          val = null;
                        }

                        const propertyType = item.get('type');
                        const estimatedValue = item.get('estimatedValue');
                        const estimatedEquity = item.get('estimatedEquity');

                        let equityPercentage = 0;
                        if (item.has('equityPercentage')) {
                          const estEquityPercentage = item.get('equityPercentage');
                          equityPercentage = estEquityPercentage;
                        } else {
                          if (estimatedValue != null && estimatedEquity != null) {
                            const estValue = parseFloat(estimatedValue);
                            const estEquity = parseFloat(estimatedEquity);

                            if (estValue > 0 && estEquity >= 0) {
                              equityPercentage = Math.round((estEquity / estValue) * 100);
                            }
                          }
                        }

                        if (!val && val !== 0 && !(index === 0 && propertyType === 'O')) {
                          return (
                            <div className={classNames(css.field, css.firstFieldNoValue)}>
                            </div>
                          );
                        }

                        return (
                          <div className={classNames(css.field, { [css.hidden]: val == null || val === '', [css.firstFieldNoValue]: (!val || val === 0), })}>
                            <div>
                              {index === 0 && (
                                propertyType === 'O' ? (
                                  <CircularProgress percentage={equityPercentage} />
                                ) : propertyTypeIcons[propertyType] ? (
                                  <div className={css.leadlistContainer}>
                                    <div className={css.imageTrigger}>
                                      <img src={propertyTypeIcons[propertyType].src} alt={propertyTypeIcons[propertyType].alt} style={{ width: '24px', height: '30px' }} />
                                    </div>
                                    <div className={css.leadlist}>
                                      <span>Lead List : {propertyTypeIcons[propertyType].label}</span>
                                    </div>
                                  </div>
                                ) : null
                              )}
                              <div>
                                {val && val !== 0 ? (
                                  <div className={css.fieldSet}>
                                    <span className={css.title}>
                                      {label.length > 14 ? `${label}` : label}
                                    </span>
                                    <span className={css.value} title={String(val)}>
                                      {label === 'Sale Price'
                                        ? `${String(val).slice(0, 11)}${String(val).length > 11 ? '...' : ''} ${isNDAState(item.getIn(['address', 'stateCode'])) ? 'EST.' : ''}`
                                        : (String(val).length > 11 ? `${String(val).slice(0, 11)}...` : val)
                                      }
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            }))}
          </div>
        )}
      </div>
      {
        !isLoading && (
          <Paginator current={pageIndex} total={pageCount} onChangePage={onChangePage} disabledAll={!lazyDone} />
        )
      }
      <ListModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        propertyId={modalPropertyId}
        displayResults={results}
        onSelect={onSelect}
        onClick={onClick}
        index={modalPropertyIndex} // Pass the state variable here
      />
    </div >
  );
};

export default Results;